const Backbone = require('backbone');
const FacetItemModel = Backbone.Model.extend({
	defaults: {
		count: 0,
		facetStr: '',
		facetQuery: '',
		facetId: 0,
		groupName: '',
		selected: false,
		url: '',
		value: ''
	}
});
module.exports = FacetItemModel;
